import React, { FC } from 'react';
import { View } from 'react-native';
import GalanoGrotesqueText from '../GalanoGrotesqueText';
import SwitchBase from '../../base/SwitchBase';
import {
  switchThumbOn,
  switchThumbOffAlt,
  switchTrackOn,
  switchTrackOff,
} from '../../../constants/palette';
import styles from './styles';

export type InSessionSwitchProps = {
  isEnabled: boolean;
  toggleSwitch: (value: boolean) => void;
};

export const InSessionSwitch: FC<InSessionSwitchProps> = (props) => {
  const { isEnabled, toggleSwitch } = props;
  const sessionText = isEnabled ? 'In Session' : 'Inactive';
  const trackColor = {
    false: switchTrackOff,
    true: switchTrackOn,
  };
  return (
    <View style={styles.sessionStateContainer}>
      <GalanoGrotesqueText>{sessionText}</GalanoGrotesqueText>
      <SwitchBase
        containerStyle={styles.switchContainer}
        isEnabled={isEnabled}
        thumbColorDisabled={switchThumbOffAlt}
        thumbColorEnabled={switchThumbOn}
        trackColor={trackColor}
        toggleSwitch={toggleSwitch}
      />
    </View>
  );
};

export default InSessionSwitch;
